import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/shared/components';

export interface ChartDataRow {
  key: string;
  label: string;
  values: string[];
  onSelect?: () => void;
}

export function ChartDataTable({
  caption,
  headers,
  rows,
}: {
  caption: string;
  headers: string[];
  rows: ChartDataRow[];
}) {
  return (
    <details className="border-line/60 mt-4 border-t pt-3">
      <summary className="text-sage cursor-pointer py-2 text-sm font-semibold">
        Diagrammdaten anzeigen
      </summary>
      <div className="mt-3 overflow-x-auto">
        <Table aria-label={caption} className="min-w-[480px]">
          <TableHeader>
            <TableRow>
              {headers.map((header) => (
                <TableHead key={header}>{header}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.key}>
                <TableCell>
                  {row.onSelect ? (
                    <button
                      type="button"
                      onClick={row.onSelect}
                      className="hover:text-sealwax font-semibold"
                      aria-label={`${row.label} fokussieren`}
                    >
                      {row.label}
                    </button>
                  ) : (
                    row.label
                  )}
                </TableCell>
                {row.values.map((value, index) => (
                  <TableCell
                    key={`${row.key}-${headers[index + 1] ?? index}`}
                    className="font-mono"
                  >
                    {value}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </details>
  );
}
